import { IconProps } from "../../utils/global-types/global-types";

const TagsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      className={className ? className : "w-[14px] h-[14px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.63.628a31 31 0 0 0-4.24.037 1.74 1.74 0 0 0-.984.404c-.81.678-2.91 2.55-5.028 5.391-.46.618-.528 1.479-.05 2.14.365.505.956 1.255 1.902 2.326 1.101 1.248 1.878 1.913 2.382 2.268.553.39 1.202.254 1.66-.115 2.816-2.262 4.641-4.632 5.278-5.52.213-.296.335-.646.36-1.013.057-.797.15-2.577.036-4.52-.044-.753-.607-1.35-1.316-1.398m-2.1 2.637c0-.548.418-.993.934-.993s.934.445.934.993-.418.992-.934.992-.935-.444-.935-.992"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default TagsIcon;
